import React from 'react';
import {StyledDot, StyledContainer} from './styles';

const DotLoading = () => (
	<StyledContainer>
		<StyledDot />
		<StyledDot />
		<StyledDot />
	</StyledContainer>
);

export {DotLoading};
